module.exports = __webpack_public_path__ + "static/media/emmali.3ed29414.jpg";